/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov, Slobodan Djordjevic
 */

import moment from "moment"
import { sharedMomentToCZ, trackEvent } from "trux"
import { getPlayersPositions } from "./playlistStore"
import { addRankingsToPlayerStats } from "../modules/Loader/loadPlayerStats"

const hashtags = "TraceMoments"

export const valueFor = (key, def, from) => {
    var value = def

    var dots = key.split(".")
    var scope = from
    for (var i = 0; i < dots.length; i++) {
        var dot = dots[i]
        try {
            scope = scope[dot]
        } catch (err) {
            // console.error(err)
            // console.error("key", key, "from", from);
            return def
        }
    }
    if (scope != null) {
        value = scope
    }

    return value
}

export const fullName2FirstLast = (fullName) => {
    let firstName = fullName.trim()
    let lastName = ""
    const nameparts = firstName.split(" ")
    if (nameparts.length > 0) {
        lastName = nameparts.pop()
        firstName = nameparts.join(" ")
    }

    return { first_name: firstName, last_name: lastName }
}

export const copy = (e) => {
    e.preventDefault()
    let el = document.getElementById("copy-link")
    el.contentEditable = true
    el.readOnly = true

    let range = document.createRange()
    range.selectNodeContents(el)
    let sel = window.getSelection()
    sel.removeAllRanges()
    sel.addRange(range) // Does not work for Firefox if a textarea or input
    if (el.nodeName === "TEXTAREA" || el.nodeName === "INPUT") {
        el.select() // Firefox will only select a form element with select()
    }
    if (
        el.setSelectionRange &&
        navigator.userAgent.match(/ipad|ipod|iphone/i)
    ) {
        el.setSelectionRange(0, 999999) // iOS only selects "form" elements with SelectionRange
    }

    try {
        document.execCommand("copy") // Security exception may be thrown by some browsers.
    } catch (ex) {
        console.warn("Copy to clipboard failed.", ex)
        alert("Copy to clipboard failed.")
    }
}

export const getUtmCodes = (utmCampaign, utmSource, utmMedium) => {
    return `utm_campaign=${utmCampaign}&utm_source=${utmSource}&utm_medium=${utmMedium}`
}

export const isMobile = () => {
    let isMobile = false
    if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        )
    ) {
        isMobile = true
    }

    return isMobile
}

export const nativeShare = (url, text) => {
    if (navigator.share && isMobile()) {
        navigator
            .share({ text, url })
            .then(() => {
                console.log("Native Share Moment", "success")
            })
            .catch((err) => {
                console.log("Native Share Moment", "failed", err)
            })
        return true
    }
    return false
}

export const facebookShare = (gameLink, userId, clipId, element) => {
    let text = `Watch this moment from Trace`
    let url = `https://facebook.com/sharer.php?display=popup&u=${gameLink}&quote=${text}&hashtag=%23${hashtags}`
    window.open(url, text, "width=600,height=400")

    trackEvent({
        action: "Facebook Pressed",
        label: "Share Button",
        element: element,
    })

    if (clipId) {
        sharedMomentToCZ({
            type: "facebook",
            user_id: userId,
            where: "main",
            moment_id: clipId,
        })
    }
}

export const twitterShare = (gameLink, userId, clipId, element) => {
    let text = `Watch this moment from @traceup`
    let twitterLink = `https://twitter.com/intent/tweet?url=${gameLink}&text=${text}&hashtags=${hashtags}`
    window.open(twitterLink, text, "width=600,height=400")

    trackEvent({
        action: "Twitter Pressed",
        label: "Share Button",
        element: element,
    })

    if (clipId) {
        sharedMomentToCZ({
            type: "twitter",
            user_id: userId,
            where: "main",
            moment_id: clipId,
        })
    }
}

export const validateEmail = (val) => {
    const regExp =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return regExp.test(String(val).toLowerCase())
}

export const validatePhone = (val) => {
    const regExp =
        /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/im
    return regExp.test(val)
}

export const calculateNoOfDaysBeforeExpiration = (uploadTime) => {
    let before90DaysDate = moment().subtract(90, "days")
    let expired = moment(uploadTime).isBefore(before90DaysDate)
    if (!expired) {
        return Math.floor(
            moment.duration(moment(uploadTime).diff(before90DaysDate)).asDays()
        )
    } else {
        return null
    }
}

export const toggleActiveInactive = (type) => {
    if (document.body.className.includes("inactive")) {
        setTimeout(() => {
            let event = new CustomEvent("controls-inactive")
            document.dispatchEvent(event)
        }, 1000)
        let event = new CustomEvent("controls-active", { detail: type })
        document.dispatchEvent(event)

        return true
    } else {
        let event = new CustomEvent("controls-inactive")
        document.dispatchEvent(event)

        return false
    }
}

export const  capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const  convertInningTitles = (string) => {
    let tagContent = "All innings"
    let parts = string.split("-")
    let inningNo = parseInt(parts[1])

    // If NaN tagContent will be `All innings`
    if(inningNo) {
        switch (inningNo) {
            case 1:
                tagContent = `1st inning`
                break
            case 2:
                tagContent = `2nd inning`
                break;
            case 3:
                tagContent = `3rd inning`
                break;
            default:
                tagContent = `${inningNo}th inning`
                break;
        }
    }
    return tagContent
}

export const getShouldShowTraceTeam = (game, user, userDivisions) => {
    let shouldShow = false
    if (!game || !user || !userDivisions || userDivisions?.length === 0) return shouldShow
    let gameDivision = game.division
    let gameDivisionId = gameDivision?.division_id
    let isUserInGameDivision = userDivisions.some(userDivision => userDivision.division_id === gameDivisionId)
    if (isUserInGameDivision && gameDivision.type === "family") {
        shouldShow = true
    }
    return shouldShow
} 

export const calculateBaseballStats = (game, inning = 'all-innings') => {
    if (game.sport_type !== "baseball" || isBaseballStatsAvailable(game.innings)) {
        return
    }

    let stats = []
    if(game) {
        let innings = inning === "all-innings" ? game.innings : {[inning]: game.innings[inning]}
        let playerStats = getPlayersPositions(innings)
        game.home_team.players.forEach(player => {
            if (player.user && !player.user.first_name) {
                player.user.first_name = ""
            }
            if (player.user && !player.user.last_name) {
                player.user.last_name = ""
            }
            let ps = playerStats.find(p => p.traceNumber === parseInt(player.trace_number))
            if(ps) {
                ps.athlete = player;
                ps.reachedSafely = 0;
                ps.atBat = 0
                ps.defensivePlay = 0
                game.events.forEach(moment => {
                    if (inning === "all-innings") {
                        if(moment.players.find(mp => ps.traceNumber === parseInt(mp.trace_number))) {
                            if(moment.tags?.find(tag => tag.name === "hit")) {
                                if(moment.tags.find(tag => tag.name === "offensive")) {
                                    ps.reachedSafely++
                                }
                                if(moment.tags.find(tag => tag.name === "defensive")) {
                                    ps.defensivePlay++
                                }
                            }
                            if(moment.tags?.find(tag => tag.name === "at-bat")) {
                                ps.atBat++
                            }
                        }
                    } else {
                        if(moment.players.find(mp => ps.traceNumber === parseInt(mp.trace_number))) {
                            if(moment.tags?.find(tag => tag.name === inning)) {
                                if(moment.tags.find(tag => tag.name === "hit")) {
                                    if(moment.tags.find(tag => tag.name === "offensive")) {
                                        ps.reachedSafely++
                                    }
                                    if(moment.tags.find(tag => tag.name === "defensive")) {
                                        ps.defensivePlay++
                                    }
                                }

                                if(moment.tags.find(tag => tag.name === "at-bat")) {
                                    ps.atBat++
                                }
                            }
                        }
                    }
                })
                stats.push(ps)
            } else {
                let stat = {
                    positions: ["-"],
                    athlete: player,
                    traceNumber: parseInt(player.trace_number),
                    reachedSafely: 0,
                    reachedSafely_rank: 0,
                    atBat: 0,
                    atBat_rank: 0,
                    defensivePlay: 0,
                    defensivePlay_rank: 0,
                    unknown:
                        !player ||
                        !player.user ||
                        player.user.last_name.includes("Tracer") ||
                        player.user.first_name.includes("Tracer"),
                    no_data: true,
                }
                stats.push(stat)
            }
        })
    }
    stats = addRankingsToPlayerStats(stats, 'defensivePlay', false)
    stats = addRankingsToPlayerStats(stats, 'atBat', false)
    stats = addRankingsToPlayerStats(stats, 'reachedSafely', false)
    return stats
}

export const getBaseballPositionSortIndex = (position) => {
    switch (position) {
        case "P":
            return 1
        case "C":
            return 2
        case "1B":
            return 3
        case "2B":
            return 4
        case "3B":
            return 5
        case "SS":
            return 6
        case "LF":
            return 7
        case "CF":
            return 8
        case "RF":
            return 9
        default:
            return 10
    }
}

export const isBaseballStatsAvailable = (innings) => {
    let statsAvailable = true

    Object.entries(innings).forEach(inning => {
        if (Object.keys(inning).length !== 0) {
            statsAvailable = false
        }
    })

    return statsAvailable
}
